module.exports = __webpack_public_path__ + "img/logo-full-2x.aec05c3f.png";